import React from "react";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Collapse } from "antd";
import { IconFaceBook, IconGOV, IconYoutube } from "../images";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { setTitlePage } from "../../utils/helper";
import { policy } from "../../services";
import { localizeRouteKey } from "../../shared/helpers";
import {
  ACCESS_TOKEN,
  PHONE_CONTACT,
  POLICY,
  ROUTER_PATH,
} from "../../common/constant";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { signOut } from "../../redux/reducers/slice/auth";
import { selectHeaderCategories } from "../../redux/reducers/slice/common";

const service = policy;

const Footer = (props: any) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const headerCategories = useSelector(selectHeaderCategories);

  const token = localStorage.getItem(ACCESS_TOKEN);

  const handleClick = (path: string, optional: string | null) => {
    if (optional) {
      setTitlePage(t("title_page_help_use"));

      service.getPolicy(optional, (data: any, err: any) => {
        if (data) {
          props.history.push(localizeRouteKey(path) + t(optional), data);
        }
      });
    } else {
      props.history.push(localizeRouteKey(path));
    }
  };

  const showCategories = (data: any) =>
    data.map((d: any, index: number) => (
      <a
        key={index}
        className="content sub-content"
        onClick={() =>
          props.history.push(
            localizeRouteKey(ROUTER_PATH.CATEGORY) +
              t(`routes.category_${d.slug}`)
          )
        }>
        {d.name}
      </a>
    ));

  const showAccountTools = () => {
    if (!token) {
      return [
        <a
          key={1}
          className="content sub-content"
          onClick={() =>
            props.history.push(localizeRouteKey(ROUTER_PATH.SIGN_IN))
          }>
          {t("footer_sign_in_account")}
        </a>,
        <a
          key={2}
          className="content sub-content"
          onClick={() =>
            props.history.push(localizeRouteKey(ROUTER_PATH.SIGN_UP))
          }>
          {t("footer_sign_up_account")}
        </a>,
        <a
          className="content sub-content"
          onClick={() =>
            handleClick(ROUTER_PATH.POLICY_AND_GENERAL_TERMS, POLICY.HELP_USE)
          }>
          {t("label_help_use")}
        </a>,
      ];
    } else {
      return [
        // <a className="content sub-content" href="#">
        //   {t("footer_tracking_order")}
        // </a>,
        <a
          key={1}
          className="content sub-content"
          onClick={() =>
            props.history.push(localizeRouteKey(ROUTER_PATH.PROFILE))
          }>
          {t("user_information")}
        </a>,
        <a
          key={2}
          className="content sub-content"
          onClick={() =>
            props.history.push(localizeRouteKey(ROUTER_PATH.ORDERS))
          }>
          {t("user_manager_order")}
        </a>,
        <a
          key={3}
          className="content sub-content"
          onClick={() =>
            props.history.push(localizeRouteKey(ROUTER_PATH.PRODUCTS_WISH))
          }>
          {t("user_wish")}
        </a>,
        <a
          className="content sub-content"
          onClick={() =>
            handleClick(ROUTER_PATH.POLICY_AND_GENERAL_TERMS, POLICY.HELP_USE)
          }>
          {t("label_help_use")}
        </a>,
        <a
          key={4}
          className="content sub-content"
          onClick={async () => await dispatch(signOut())}>
          {t("btn_sign_out")}
        </a>,
      ];
    }
  };

  const content = [
    {
      title: t("footer_title_product"),
      values:
        headerCategories &&
        headerCategories.header_category_id &&
        headerCategories.header_category_id.length
          ? showCategories(
              _.sortBy(
                headerCategories.header_category_id.filter(
                  (m: any) =>
                    m.is_parent && m.is_actived && m.category_ids.length
                ),
                ["order"]
              )
            )
          : [],
    },
    {
      title: t("footer_title_about"),
      values: [
        <a
          key={1}
          className="content sub-content"
          onClick={() =>
            handleClick(
              ROUTER_PATH.POLICY_AND_GENERAL_TERMS,
              POLICY.INTRO_COMPANY
            )
          }>
          {t("about_kymdan")}
        </a>,
        <a
          key={2}
          className="content sub-content"
          onClick={() =>
            props.history.push(localizeRouteKey(ROUTER_PATH.STORE_AGENCY))
          }>
          {t("experience_system")}
        </a>,
        <a
          key={3}
          className="content sub-content"
          onClick={() =>
            props.history.push(localizeRouteKey(ROUTER_PATH.EVENT))
          }>
          {t("event")}
        </a>,
        <a
          key={4}
          className="content sub-content"
          onClick={() =>
            handleClick(ROUTER_PATH.POLICY_AND_GENERAL_TERMS, null)
          }>
          {t("policy_title")}
        </a>,
        <a
          key={5}
          className="content sub-content"
          onClick={() =>
            handleClick(
              ROUTER_PATH.POLICY_AND_GENERAL_TERMS,
              POLICY.HELP_SECURITY
            )
          }>
          {t("help_security_label")}
        </a>,
        <a
          key={6}
          className="content sub-content"
          onClick={() => handleClick(ROUTER_PATH.WARRANTY, null)}>
          {t("warranty_title")}
        </a>,
      ],
    },
    {
      title: t("footer_title_account"),
      values: showAccountTools(),
    },
  ];

  const contact = {
    title: t("kymdan_company"),
    values: [
      <div key={1} className="footer-item kd-certification">
        <span className="content sub-content">
          Giấy chứng nhận đăng ký doanh nghiệp số 0301 666 989 do Sở Kế Hoạch và
          Đầu Tư TP.HCM cấp lần đầu ngày 05 tháng 03 năm 1999.
        </span>
      </div>,
      <div key={2} className="footer-item">
        <span className="content sub-content">{t("address")}:</span>
        <a
          className="content sub-content "
          href="http://maps.google.com/?q=28 Bình Thới, Phường 14, Quận 11, Thành phố Hồ Chí Minh">
          {t("address_detail")}
        </a>
      </div>,
      <div key={5} className="footer-item">
        <span className="content sub-content" style={{ marginTop: "0px" }}>{t("address_detail_new")}</span>
      </div>,
      <div key={3} className="footer-item">
        <span className="content sub-content">{t("tel")}:</span>
        <a className="content sub-content" href={`tel:${PHONE_CONTACT}`}>
          {PHONE_CONTACT}
        </a>
      </div>,
      <div key={4} className="footer-item">
        <span className="content sub-content">Email:</span>
        <a className="content sub-content" href="mailto:contactus@kymdan.com">
          contactus@kymdan.com
        </a>
      </div>,
    ],
  };

  const social = [
    { src: IconFaceBook, url: "https://www.facebook.com/kymdanofficial/" },
    // { src: IconTwister, url: "#" },
    {
      src: IconYoutube,
      url: "https://www.youtube.com/channel/UCwbZ6NS_2aokIYMWpJGNL2w",
    },
  ];

  return (
    <div className="footer-container">
      <div className="footer-wrapper">
        <div className="footer-item-wrapper">
          {content.map((item: any, index: number) => (
            <div key={index} className="footer-item-wrap width-200">
              <div className="footer-item-title main-content">{item.title}</div>
              <div className="footer-item-values">
                {item.values.map((value: any) => value)}
              </div>
            </div>
          ))}
        </div>
        <div className="footer-item-wrapper">
          <div className="footer-item-wrap">
            <div className="footer-item-title uppercase main-content">
              {contact.title}
            </div>
            <div className="footer-item-values">
              {contact.values.map((value: any) => value)}
            </div>
          </div>
        </div>
        <div className="footer-collapse-wrapper">
          <Collapse
            accordion
            bordered={false}
            ghost
            expandIconPosition="right"
            expandIcon={({ isActive }) =>
              isActive ? <MinusOutlined /> : <PlusOutlined />
            }>
            {content.map((item: any, index: any) => (
              <Collapse.Panel header={item.title} key={index + 1}>
                {item.values.map((value: any) => value)}
              </Collapse.Panel>
            ))}
          </Collapse>
        </div>
      </div>
      <div className="footer-wrapper">
        <div className="footer-item-social-wrapper">
          <div className="footer-social-wrapper">
            <div className="content sub-content">Social</div>
            <div className="footer-social-item-wrap">
              {social.map((item: any, index: number) => (
                <a key={index} href={item.url} target="blank">
                  <img src={item.src} alt="" />
                </a>
              ))}
            </div>
          </div>
          <div className="footer-application-wrapper">
            <div className="content sub-content">Ứng dụng Kymdan Store</div>
            <div className="footer-application-item-wrap">
              <div>
                <a style={{ cursor: "inherit" }}>
                  <img
                    src="https://kdstore-testing.s3.ap-southeast-1.amazonaws.com/product_images/1630058585-TaiApp-46.svg"
                    alt=""
                  />
                </a>
              </div>
              <div className="footer-application-item">
                <a
                  href="https://play.google.com/store/apps/details?id=com.kymdan.store&hl=vi"
                  target="blank">
                  <img
                    src="https://kdstore-testing.s3.ap-southeast-1.amazonaws.com/product_images/1630058581-TaiApp-47.svg"
                    alt=""
                  />
                </a>
                <a
                  href="https://apps.apple.com/us/app/kymdan-store/id1442498477"
                  target="blank">
                  <img
                    src="https://kdstore-testing.s3.ap-southeast-1.amazonaws.com/product_images/1630058570-TaiApp-83.svg"
                    alt=""
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="footer-item-mobile-wrap">
            <div className="footer-item-wrap">
              <div className="footer-item-title uppercase main-content">
                {contact.title}
              </div>
              <div className="footer-item-values">
                {contact.values.map((value: any) => value)}
              </div>
            </div>
          </div>
        </div>
        <div className="footer-gov-copyright-wrap">
          <div className="kd-gov">
            <a href="http://online.gov.vn/Home/WebDetails/87787" target="blank">
              <img alt="" title="" src={IconGOV} />
            </a>
          </div>
          <div className="footer-copyright-wrapper">
            <div className="content sub-content">® Copyright 2021 Kymdan</div>
            <div className="content sub-content mt-0">
              {t("version")}1.0.0.0
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
